import { Dictionary } from '@/dictionary/Dictionary'
import i18n from '@/i18n'

enum tariffTypes {
    TO_DOOR = 'to_door',
    TO_POSTAMAT = 'to_postamat',
    TO_STORE = 'to_store'
}

const tariffTypesDict: Array<Dictionary> = []

for (const code in tariffTypes) {
    const value = tariffTypes[code]
    tariffTypesDict.push({
        code: value,
        name: i18n.t(`dictionary.tariffTypes.${value}`).toString()
    })
}
export { tariffTypesDict, tariffTypes }
